import axios from "axios";

export const Api = axios.create({
  baseURL: process.env.REACT_APP_HOST,
  validateStatus: function (status) {
    return status >= 200 && status <= 500;
  },
});

axios.interceptors.response.use((response) => {
  response.headers['Referrer-Policy'] = 'no-referrer';
  response.headers['Permissions-Policy'] = 'geolocation=(self "/")';
  response.headers['Content-Security-Policy'] = "default-src 'self'";
  response.headers['X-XSS-Protection'] = '0';
  response.headers['X-Frame-Options'] = 'SAMEORIGIN';
  response.headers['X-Content-Type-Options'] = 'nosniff'; 
  return response;
}, (error) => {
  return Promise.reject(error);
});